export default __webpack_public_path__ + "static/media/Lock.ab02331c.svg";